import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';

import type { GetCourseByIdResponseType } from '@/helpers/interfaces/course.interface';
import type { Paginated } from '@/helpers/interfaces/paginated.interface';
import { axiosI } from '@/plugins';
import type { UserWishlistedCourse } from '@/submodules/generated_types/types/user_wishlisted_course';
import { ApiHandler } from '@/submodules/postman-to-ts/apiHandler';

interface CoursesInterface {
  [key: string]: GetCourseByIdResponseType;
}
interface LoadingCoursesInterface {
  [key: string]: boolean;
}
interface FetchingCoursesInterface {
  [key: string]: boolean;
}
export const useCoursesStore = defineStore('CoursesStore', () => {
  const courses: Ref<CoursesInterface> = ref({});
  const wishlistCourses: Ref<Paginated<UserWishlistedCourse>> = ref({
    data: [],
    count: 0,
  });
  const isFetchingCourses: Ref<FetchingCoursesInterface> = ref({});
  const isLoadingCourses: Ref<LoadingCoursesInterface> = ref({});
  function setCourses(newCourses: GetCourseByIdResponseType, id: string) {
    courses.value[id] = newCourses;
  }
  function getCourse(id: string) {
    return courses.value[id];
  }

  function setIsFetchingCourses(id: string, value: boolean) {
    isFetchingCourses.value[id] = value;
  }
  function getIsFetchingCourses(id: string) {
    return isFetchingCourses.value[id];
  }
  function setIsLoadingCourses(id: string, value: boolean) {
    isLoadingCourses.value[id] = value;
  }
  function getIsLoadingCourses(id: string) {
    return isLoadingCourses.value[id];
  }

  async function getUserWishlist(userId: number) {
    const { path, method } = ApiHandler.lMS.users.wishlist.getWishlistedCourses;
    const response = await axiosI<Paginated<UserWishlistedCourse>>(
      path({ userId }),
      {
        method,
        params: {
          skip: 0,
          take: Number.MAX_SAFE_INTEGER,
        },
      }
    );
    wishlistCourses.value = response.data;
    return response.data;
  }
  async function addCourseToWishlist(userId: number, courseId: number) {
    const { path, method } = ApiHandler.lMS.users.wishlist.wishlistCourse;
    const response = await axiosI<Paginated<UserWishlistedCourse>>(
      path({ userId, courseId }),
      {
        method,
      }
    );
    return response.data;
  }
  return {
    courses,
    addCourseToWishlist,
    setCourses,
    getCourse,
    getUserWishlist,
    isFetchingCourses,
    setIsFetchingCourses,
    getIsFetchingCourses,
    isLoadingCourses,
    wishlistCourses,
    setIsLoadingCourses,
    getIsLoadingCourses,
  };
});
